import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { mergeMap } from 'rxjs/operators';

import { DeviceNotesService } from '@rocksoft/mdm-sdk-v2';
import { safeMap } from '../effects.helpers';
import { NotesApiActions, NotesResolverActions, NotesUIActions } from './notes.actions';

@Injectable()
export class NotesEffects {
  private readonly deviceNotesService = inject(DeviceNotesService);
  private readonly actions$ = inject(Actions);

  notesRequestedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesResolverActions.notesRequested),
      mergeMap(({ udid }) =>
        safeMap(
          this.deviceNotesService.getAllNotes({ udid, deviceType: 'Apple', apiVersion: '2.0' }),
          (notes) => NotesApiActions.notesLoaded({ notes, udid }),
          (error) => NotesApiActions.notesLoadedError({ error })
        )
      )
    );
  });

  noteAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesUIActions.noteAdded),
      mergeMap(({ note, udid }) =>
        safeMap(
          this.deviceNotesService.addNote({
            udid,
            deviceType: 'Apple',
            apiVersion: '2.0',
            createNote: { content: note.content },
          }),
          (createdNote) => NotesApiActions.noteAdded({ note: createdNote, udid }),
          (error) => NotesApiActions.noteAddedError({ error })
        )
      )
    );
  });

  noteDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotesUIActions.noteDeleted),
      mergeMap(({ note, udid }) =>
        safeMap(
          this.deviceNotesService.deleteNote({ id: note.id, deviceType: 'Apple', udid, apiVersion: '2.0' }),
          () => NotesApiActions.noteDeleted({ note, udid }),
          (error) => NotesApiActions.noteDeletedError({ error })
        )
      )
    );
  });
}
